import React, { forwardRef, useImperativeHandle, useState } from 'react'
import ReactDOM from 'react-dom'
import ReactDOMClient from 'react-dom/client'
import classNames from 'classnames'
import Notice from './notice'

let seed = 0
const now = Date.now()

function getUuid() {
  return `rcNotification_${now}_${seed++}`
}

const Notification = forwardRef(({ closeIcon, maxCount, placement, duration, prefixCls, style, className }, ref) => {
  const [notices, setNotices] = useState([])

  const add = (notice) => {
    notice.key = notice.key || getUuid()
    const key = notice?.key || getUuid()
    setNotices(preNotices => {
      // 要添加的notice是否已经存在
      const noticeIndex = preNotices.findIndex(v => v.key === key)
      // 使用concat()来复制notice数组
      const updatedNotices = preNotices.concat()
      // 如果要加的notice已经存在
      if (noticeIndex !== -1) {
        // 删除已存在的notice，加入要添加的notice
        updatedNotices.splice(noticeIndex, 1, notice)
      } else {
        // 如果设置了maxCount，且notices中的数量已达到maxCount的限制，那么移除第一个notice
        if (maxCount && preNotices.length >= maxCount) {
          // updateKey设置为最初移除的key，最要是为了利用已存在的组件
          notice.updateKey = updatedNotices[0].updateKey || updatedNotices[0].key
          updatedNotices.shift()
        }
        // 加入的要添加的notice
        updatedNotices.push(notice)
      }
      return updatedNotices
    })
  }

  const remove = (key) => {
    setNotices(pre => {
      return [...pre.filter(notice => notice.key !== key)]
    })
  }

  useImperativeHandle(ref, () => {
    return {
      add,
      remove,
    }
  })
  console.log(notices)
  return <div className={classNames(`${prefixCls}-notification`, placement, className)} style={style}>
    {
        notices.map((notice, index) => {
          // 如果notice是数组最后一个，且存在updateKey。
          // 说明，该notice添加进来之前，数组已经达到maxCount,并挤掉了数组的第一个noitce。
          // update 为true，是由于重用了之前被挤掉的notice的组件，需要更新重启Notice组件的定时器
          const update = Boolean(index === notices.length - 1 && notice.updateKey)
          // key相同，若组件属性有所变化，则react只更新组件对应的属性；没有变化则不更新。
          const key = notice.updateKey ? notice.updateKey : notice.key
          return (<Notice
            prefixCls={prefixCls}
            duration={duration}
            {...notice}
            key={key}
            update={update}
            onClose={() => {
              remove(notice.key)
              notice.onClose?.()
            }}
            closeIcon={closeIcon}
          >
            {notice.content}
          </Notice>)
        })
    }
  </div>
})

Notification.newInstance = function newNotificationInstance(properties, callback) {
  const { getContainer, ...props } = properties || {}
  const div = document.createElement('div')
  let clientRoot = null
  if (getContainer) { // getContainer是函数，返回HTMLElement。返回结果将作为notification挂载的容器
    const root = getContainer()
    root.appendChild(div)
  } else {
    document.body.appendChild(div)
  }

  // 由上可知，其实notification最后都挂载在div中
  let called = false

  // 参数notification是指Notification组件
  function ref(notification) {
    // 设置变量called的原因是
    // 因为ref回调会在一些生命周期回调之前执行，这里为了保证ref回调在组件的所有生命周期中只执行完整的一次，所以才使用了一个布尔值。
    if (called) {
      return
    }
    called = true
    // 传进来的callback函数，接收一个对象，该对象可以增加notice,移除notice,提供组件的引用，销毁组件
    callback({
      notice(noticeProps) {
        notification.add(noticeProps)
      },
      removeNotice(key) {
        notification.remove(key)
      },
      component: notification, // compoent可以向外暴露Notification实例
      destroy() {
        if (ReactDOM?.unmountComponentAtNode) {
          const unmountResult = ReactDOM?.unmountComponentAtNode(div) // 从div中移除已挂载的Notification组件
          if (unmountResult && div.parentNode) {
            div.parentNode?.removeChild(div)
          }
        }
        if (clientRoot) {
          clientRoot.unmount()
        }
      },
    })
  }
  if (ReactDOM?.render) {
    ReactDOM?.render(<Notification {...props} ref={ref} />, div)
  } else if (ReactDOMClient.createRoot) {
    clientRoot = ReactDOMClient.createRoot(div)
    clientRoot.render(<Notification {...props} ref={ref} />)
  }
}

export default Notification
